// src/app/views/pages_pub/bar/rtPbBar.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const BarLand = Loadable(lazy(() => import("./BarLand")));
const BarApply = Loadable(lazy(() => import("./BarApply")));
// const BarApplyVeritas = Loadable(lazy(() => import("./BarApplyVeritas")));
const BarApplyPsatCamp = Loadable(lazy(() => import("./BarApplyPsatCamp")));
const pathExt = getPathByCdExt(EXAM_TYPES.BAR.rid_cd_ext);

const rtPbBar = [
  { path: `/pub/${pathExt}/land/:rid_cd_ext/:rid_imp_sr`, element: <BarLand /> },
  { path: `/pub/${pathExt}/apply/:rid_cd_ext/:rid_imp_sr/:gid?`, element: <BarApply /> },
  // { path: `/pub/${pathExt}/apply-veritas/:rid_cd_ext/:rid_imp_sr`, element: <BarApplyVeritas /> },
  // { path: `/pub/${pathExt}/app_psat_camp`, element: <BarApplyPsatCamp /> }
];
export default rtPbBar;
